<div class="ttmodal" *ngIf="isReturn==false">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Move to Repairer</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">


        <div class="input-container">
            <span class="label">Select Repairer</span>
            <select (change)="repairerSelected($event.target.value)" [(ngModel)]="repairerId" class="get-Input">
                <option value="" disabled selected>Select Repairer</option>
                <option *ngFor="let repairer of repairerList" [value]="repairer.Id"> {{repairer.Name}}</option>
            </select>
        </div>


        <div class="input-container">
            <span class="label">Select Job Site</span>
            <select [(ngModel)]="workshopId" class="get-Input">
                <option value="" disabled selected>Select Jobsite</option>
                <option *ngFor="let job of workshopList" [value]="job.Id"> {{job.Name}}</option>
            </select>
        </div>



    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" [class.loading]="savingChanges" (click)="MoveImplementToRepairer()"><span
                class="button__text">Save</span></a>
    </div>
</div>

<div class="ttmodal" *ngIf="isReturn==true">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Return to Inventory</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">


        <!-- <div class="input-container">
          <span >Are you sure you want to move back to the Inventory</span>
      </div>    -->


        <div class="input-container">
            <span class="label">Customer</span>
            <select (change)="loadJobsitesForCustomer()" [(ngModel)]="selectedCustomer" class="get-Input">
                <option value="" disabled selected>Select Customer</option>
                <option *ngFor="let customer of customerList" [value]="customer.Id">{{customer.Name}}</option>
            </select>
        </div>
        <div class="input-container">
            <span class="label">Jobsite</span>
            <select [(ngModel)]="selectedJobsite" required class="get-Input">
                <option value="" disabled selected>Select Jobsite</option>
                <option *ngFor="let job of jobsiteList" [value]="job.Id">{{job.Name}}</option>
            </select>
        </div>
    </div>

    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" [class.loading]="savingChanges" (click)="ReturntoTheInventory()"><span
                class="button__text">Return To Inventory</span></a>
    </div>
</div>